



































import {Component, Prop, Provide, Vue} from 'vue-property-decorator'
import {Category} from '@/model/resource/Category'
import {InputCategorySchema} from '@/schema/resource/Category/InputCategorySchema'

@Component
export default class PersistCategoryView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputCategorySchema()
  category = new Category()

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.category.getCategory(id)
    }

    this.$await.done('getCategory')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      this.$toast.abort('system.error.validation')
    }

    await this.category.persistCategory()
    this.$toast.success('system.success.persist')
    await this.$nav.push('/category/list')
  }
}
